export default import.meta.ROLLDOWN_FILE_URL_4zy8vDEQU4KpveeRNJqB5A